import React, { Component } from "react";
import { Platform, TouchableOpacity, View } from "react-native";
import Text from "./TextFont";
import PropTypes from "prop-types";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";
export class IconButton extends Component {
  constructor(props) {
    super(props);
  }

  handleOnPress = () => {
    this.props.onPress && this.props.onPress();
  };
  handleOnLongPress = () => {
    this.props.onLongPress && this.props.onLongPress();
  };

  render() {
    let subIcon = null;
    if (this.props.subIcon) {
      subIcon = (
        <Text
          style={
            Platform.OS === "web"
              ? {
                  ...this.props.subIcon.style,
                  position: "absolute",
                  top: 0,
                }
              : {
                  position: "absolute",
                  top: -3,
                  ...this.props.subIcon.style,
                }
          }
        >
          {this.props.value || this.props.icon.code}
        </Text>
      );
    }

    let caption = null;
    if (this.props.caption) {
      caption = (
        <Text
          style={{
            ...this.props.caption.style,
          }}
        >
          {this.props.caption.text}
        </Text>
      );
    }
    var _mainStyle = {};
    var _wrapperStyle = { flexDirection: "column", alignItems: "center" };
    if (this.props.style) {
      if (Array.isArray(this.props.style)) {
        _mainStyle = [...this.props.style, _wrapperStyle];
      } else {
        _mainStyle = {
          ...this.props.style,
          ..._wrapperStyle,
        };
      }
    }
    return (
      <TouchableOpacity
        onPress={this.handleOnPress || this.props.func}
        onLongPress={this.handleOnLongPress}
        style={_mainStyle}
      >
        <View
          style={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {subIcon}
          <Text
            style={{
              ...this.props.icon.style,
            }}
          >
            {this.props.icon.code}
          </Text>
        </View>
        {caption}
      </TouchableOpacity>
    );
  }
}

/**@augments{Component<props, state>} */
export class ShortcutButton extends Component {
  static propTypes = {
    onPress: PropTypes.func,
    onDelete: PropTypes.func,
  };

  constructor(props) {
    super(props);
  }

  handleOnPress = () => {
    this.props.onPress && this.props.onPress();
  };

  render() {
    var hasCaption =
      this.props.icon.caption && this.props.icon.caption.length > 0;
    return (
      <View style={{ maxWidth: "25%", minWidth: 80 }}>
        {/**delete icon */}
        {this.props.isRemovable && (
          <TouchableOpacity
            onPress={() => {
              this.props.onDelete && this.props.onDelete();
            }}
            style={{
              width: 20,
              height: 20,
              borderRadius: 10,
              backgroundColor: "#F00",
              position: "relative",
              top: 5,
              start: 0,
              justifyContent: "center",
              //alignSelf: "flex-start",
            }}
          >
            <Text
              style={{
                fontFamily: "FontAwesomeProLight",
                color: "white",
                textAlign: "center",
              }}
            >
              {faCharCodes.faTimes}
            </Text>
          </TouchableOpacity>
        )}
        {/**main icon */}
        <IconButton
          onPress={this.handleOnPress}
          style={{
            ...this.props.style,
            backgroundColor:
              this.props.typeShortcut === "scenario"
                ? this.props.enable
                  ? Theme.COLORS.PRIMARY
                  : Theme.COLORS.MUTED
                : this.props.style.hexColor + 0.1 * 100,
            width: 35,
            height: 35,
            borderRadius: 5,
            marginBottom: 8,
            // padding: 10,
            alignItems: "center",
            alignSelf: "center",
            justifyContent: "center",
            // === boxShadow ===
            shadowColor:
              this.props.typeShortcut === "scenario"
                ? this.props.enable
                  ? Theme.COLORS.PRIMARY
                  : Theme.COLORS.MUTED
                : Theme.COLORS.BACKGROUND, //this.props.style.hexColor + 0.1 * 100,
            shadowOffset: {
              width: 0,
              height: 5,
            },
            shadowOpacity: 0.3,
            shadowRadius: 6.65,
            elevation: this.props.typeShortcut === "scenario" ? 9 : 1,
          }}
          icon={{
            code: this.props.icon.code,
            style: {
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_REGULAR,
              fontSize: 15,
              color:
                this.props.typeShortcut === "scenario"
                  ? Theme.COLORS.WHITE
                  : this.props.style.hexColorIcon || this.props.style.hexColor,
              transform: [{ rotate: this.props.icon.rotate || "0deg" }],
            },
          }}
        />
        {hasCaption && (
          <Text
            numberOfLines={1}
            ellipsizeMode="middle"
            style={{
              fontSize: 13,
              textAlign: "center",
              color: "#666666",
              // marginBottom: 10,
              width: "100%",
              ...this.props.captionStyle,
            }}
          >
            {this.props.icon.caption}
          </Text>
        )}
      </View>
    );
  }
}

export class AreaItemButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <IconButton
        icon={{
          code: this.props.icon.code,
          style: {
            fontFamily: faCharCodes.FONT_FAMILIES.PRO_REGULAR,
            fontSize: 70,
            color: this.props.style.hexColor,
            transform: [{ rotate: this.props.icon.rotate || "0deg" }],
          },
        }}
      />
    );
  }
}

/**@augments{Component<props, state>} */
export class SimpleIcon extends Component {
  static propTypes = {
    color: PropTypes.string,
    icon: PropTypes.string.isRequired,
    size: PropTypes.number,
    style: PropTypes.shape(),
    fontFamily: PropTypes.oneOf([
      faCharCodes.FONT_FAMILIES.PRO_REGULAR,
      faCharCodes.FONT_FAMILIES.PRO_LIGHT,
    ]),
  };

  render() {
    var _size = this.props.size || 11;
    var _color = this.props.color || "#000";
    var _fontFamily =
      this.props.fontFamily || faCharCodes.FONT_FAMILIES.PRO_LIGHT;
    var _style = this.props.style || {};
    return (
      <Text
        style={{
          fontFamily: _fontFamily,
          color: _color,
          fontSize: _size,
          ..._style,
        }}
      >
        {this.props.icon}
      </Text>
    );
  }
}
